import {
  LoadManifests,
  SetManifests,
  LoadCurrentManifest,
  SetCurrentManifest,
  CreateManifest,
  SetManifestError,
  RemoveManifestError,
} from './manifest.actions';
import { ManifestApiError } from './manifest.errors';
import { Manifest } from 'src/app/admin/models/manifest.model';
import { createReducer, on } from '@ngrx/store';

export interface ManifestState {
  manifests: Manifest[];
  currentManifest: Manifest;
  apiError: ManifestApiError;
}

const initialState: ManifestState = {
  manifests: null,
  currentManifest: null,
  apiError: null,
};

export const manifestReducer = createReducer(
  initialState,
  on(LoadManifests, LoadCurrentManifest, CreateManifest, RemoveManifestError, (state) => ({
    ...state,
    apiError: null,
  })),
  on(SetManifests, (state, { manifests }) => ({ ...state, manifests })),
  on(SetCurrentManifest, (state, { manifest }) => ({ ...state, currentManifest: manifest })),
  on(SetManifestError, (state, { error }) => ({ ...state, apiError: error })),
);
